export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <span className="text-xl font-heading text-primary-400">51cg吃瓜</span>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-md">
              国内领先的网红八卦与明星争议资讯聚合平台。专注于51吃瓜台北娜娜、莫里秀、玩偶姐姐等热门人物的动态追踪与深度深扒，为百万吃瓜群众提供第一手、多维度、经核验的热门人物黑料与争议事件报道。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-300 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#updates" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</a>
              <a href="#topics" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#cards" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">深度扒文</a>
              <a href="#carousel" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#contact" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">更多合作伙伴即将入驻，敬请期待。如有合作意向，欢迎通过上方联系方式与编辑团队沟通。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© {currentYear} 51cg吃瓜. All Rights Reserved. 理性吃瓜，深度追踪。</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}